// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1rSbk","alertIcon":"ConfirmModal_alertIcon__2rkOX"};